let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e3JqP")).then(() => parcelRequire('adonc'));